/* eslint-disable no-unsafe-optional-chaining ,no-nested-ternary  */

import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import Navigation from 'support/navigation'
import './IdeaChallengePopup.css'; // Add your styles here
import { DropdownSelect } from './SelectableComponent'; // Your custom dropdown
import { func } from 'prop-types';
// import ChallengeCard, { getInitiativeFlag } from '../challenge_card/View'
import defaultImg from 'img/hero_image.png';
import { makeStyles } from '@material-ui/core/styles';
import NxtCircularLoader from 'components/nxt_circular_loader/View'
import { BiBulb } from "react-icons/bi";
import ChallengeImage from '../challenge_card/ChallengeImage';
import { format } from 'date-fns';
import EmptyState from 'pagesNewUi/new_all_challenges/EmptyState';
import ExpiryInfo from '../challenge_card/ExpiryInfo';

const IdeaChallengePopup = (props) => {

  // console.log("🚀 ~ IdeaChallengePopup ~ props:", props)

  const { isAdmin, filterListInnovateChallengeTotal,onClickLoadMore,onClose, challengesList, submitYourIdea,enableIsHackathon,listInnovateChallengeLoading} = props || {}

  const [selectedChallengeCard, setSelectedChallengeCard] = useState(null); // 'innovate' or 'nova'
  const [challengeType, setChallengeType] = useState(null); // 'innovate' or 'nova'
  const [selectedOption, setSelectedOption] = useState('');
  const [options, setOptions] = useState([]);
  const history = useHistory();


// console.log("condition challengesList",challengesList)


const activeChallenges = (challengesList ?? []).filter(
  item => item?.status === "ACTIVE"
);



  // useEffect(() => {
  //   const formatted = challengesList.map((challenge) => ({
  //     value: challenge.id,
  //     label: challenge.name,
  //     type: challenge.isInnovate ? 'nova' : null, // assuming non-innovate is nova
  //   }));
  //   setOptions(formatted);
  // }, [challengesList]);

  // const filteredOptions = options.filter(opt => opt.type === challengeType);

  // const handleContinue = () => {
  //   if (!selectedOption) return alert('Please select a challenge.');
  //   // const route = challengeType === 'nova' ? `${Navigation.navigateToInnovateIdeaSubmit()}` : null;
  //   Navigation.navigateToInnovateIdeaSubmit()
  //   // history.push(route);
  //   onClose();
  //   return false
  // };

  // const handleNewIdeaRoute = ()=>{
  //     Navigation.navigateToIdeaNew()
  //     onClose();
  // }


  const onHandlePostAnIdea = (challengeParamsItem) => {
    // console.log("challengeParamsItem==>", challengeParamsItem)
    const targetPath = Navigation.navigateToInnovateIdeaSubmit();
  
    history.replace({
      pathname: targetPath,
      state: { challenge:challengeParamsItem }
    });
    onClose();
  }; 

  // const handleContinue = () => {

  //   const targetPath = selectedChallengeCard?.isInnovate === true ?  Navigation.navigateToInnovateIdeaSubmit() :  Navigation.navigateToIdeaNew();

  //   // history.push({
  //     history.replace({
  //     pathname: targetPath,
  //     state: { challenge: selectedChallengeCard }
  //   });
  //   onClose();
  // };
    
  const handleSelectedChallenge = (SelectedItem)=>{
    setSelectedChallengeCard(SelectedItem)
  }
  // console.log("selectedChallengeCard",selectedChallengeCard,  )


  return (
    <div className="popup-overlay">
      <div className="popup-container1">
        <h2>Choose what challenge your idea is solving</h2>
        <NxtCircularLoader isLoading={listInnovateChallengeLoading}>
        {
            Array.isArray(activeChallenges) && activeChallenges.length > 0 ?
              (
                <div className='autoscoll'>
                <div className='gridcols'>
        {activeChallenges?.map(challenge => {
          
          // const imglist = challenge?.images.map((item)=>item?.url)
          const imglist = challenge?.images[0]?.url || challenge?.image?.url || defaultImg
          const endingDate =   challenge?.ends?.dateString || null
          const formatEndDate = endingDate ? format(new Date(endingDate), 'dd MMM yy') : null;

          return (<ChallengeCardSelect 
            key={challenge.id}
            images={imglist}
            decs={challenge?.descWithoutTags || ''}
            submissionsEnd={formatEndDate || null}
            challengeTitle={challenge.name || challenge.title}
            isHackathonEnable={enableIsHackathon}
            onClick={()=>onHandlePostAnIdea(challenge)}
            isInnovate={challenge?.isInnovate}
            isHackathonChallenge={challenge?.isHackathonChallenge}
            innovateChallengeTagIdeaCount={challenge.numIdeas}
            // onClick={()=>handleSelectedChallenge(challenge)}
            // selectedChallengeId={selectedChallengeCard?.id}
            // singleChallengeId={challenge?.id}
          />
        )},
       
          )}
      </div>

          {
            isAdmin ? (
              filterListInnovateChallengeTotal === 1 ? null : (
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <button type="button" className="viewlink" onClick={onClickLoadMore}>
                    Load more
                  </button>
                </div>
              )
            ) : null
          }

        {/* { filterListInnovateChallengeTotal > 1 &&
          <div style={{ display: 'flex', justifyContent: 'center' }}>
          <button type='button' className='viewlink' onClick={onClickLoadMore}>
            Load more
          </button>
          </div>
        } */}
        </div>
      

              ) :
              (
                <EmptyState  />
              )
        }
        
        </NxtCircularLoader>


        {/* {!challengeType ? (
          <>
          <h2>Before posting an idea, please select an option to add your idea.</h2>

          <div style={{ display: 'flex', gap: '10px' }}>
            <button type='button' className='challenge-card innovate' onClick={() => setChallengeType('nova')}>Innovate</button>
            <button type='button' className='challenge-card nova' onClick={handleNewIdeaRoute}>Nova</button>
          </div>
          </>
        ) : (
          <>
            <h3>Select Challenges</h3>
            <DropdownSelect
              // options={filteredOptions}
              options={options}
              selected={selectedOption}
              onChange={setSelectedOption}
            />
            <button type='button' className="close-btn" onClick={handleContinue}>
              Continue
            </button>
            <button type='button' className="close-btn" onClick={onClose}>
              close
            </button>
          </>
        )} */}
        {/* {console.log("enableIsHackathon && selectedChallengeCard?.isInnovate === true", enableIsHackathon ,enableIsHackathon && !(selectedChallengeCard?.isInnovate) )} */}
         {/* <button type='button' 
          className="close-btn" 
          onClick={handleContinue}
          disabled={enableIsHackathon  && !(selectedChallengeCard?.isInnovate) }
         >
              Continue
          </button> */}
          <button type='button' className="close-btn" 
          onClick={onClose}
          >
            close
          </button>
      </div>
    </div>
  );
};

export default IdeaChallengePopup;






const useStylesChallengeSelectCard = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  heading:{
    fontFamily: 'VodafoneRg-Regular',
    fontSize:'1.125rem',
    marginBottom:'8px',
    textAlign:'left',
    color:'#333',
  },
  flags:{
    backgroundColor:'#ecd8d8',
    padding:"1rem",
    fontFamily: 'VodafoneRg-Regular',
    fontSize:'1rem',
    marginBottom:'1rem'
  },
  cardBox:{
      // backgroundColor: 'rgba(230, 0, 1, 0.09)',
      // padding:'1rem',
      // border:0,
      // borderRadius:'4px',
      // marginBottom:'1rem',
      // minWidth:'200px',
    width:'100%',
    border: '1px solid #CCCCCC',
    // height: '215px',
    margin: '0',
    // display: 'grid',
      display: 'flex',
    gap:'8px',
    overflow: 'hidden',
    borderRadius: '16px',
    gridTemplateColumns: '1fr 1fr',
    maxHeight:'240px',
    height:'210px'
  },
  selectedChallenge:{
      boxShadow: '-3px 4px 1px #ec2828'
  },
  selectbtn:{
      color: '#fff',
      cursor:'pointer',
      border: '1px solid',
      borderColor:'#e60000', 
      display: 'block',
      padding: '0.5rem',
      fontSize: '1rem',
      boxSizing: 'border-box',
      textAlign: 'center',
      transition: 'all 300ms ease',
      fontFamily: 'VodafoneRg-Regular',
      borderRadius: '5px',
      backgroundColor: '#e60000',
  },
  block1:{
    position:'relative',
    maxWidth:'49%',
    '& img':{
      width:'100%',
      height:'100%',
      objectFit: 'cover'
    }
  },
  block2:{
    maxWidth:'49%',
    // padding:'1rem',
    marginLeft:'1rem',
    display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between'
  },
  textsmall:{
    fontFamily: 'VodafoneRg-regular', 
    margin: '0 0 0 0', 
    fontSize: '0.8rem',
    textAlign: 'left',
    color:'#333',
    lineHeight: '1.4',
    display: '-webkit-box',
    WebkitLineClamp: 3,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    '& span': {
      fontFamily: 'VodafoneRg-Bold',
    },

},


expiry_box: {
  backgroundColor: "#666796",
  border: "1px solid #FFFFFF",
  borderRadius: "3px",
  opacity: 0.95,
  height: "50px",
  width: "142px",
  position: "relative",
  top: -66,
  left: 16,
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  "&.expired": {
    backgroundColor: "#FFFFFF",
    border: "1px solid black",
  },
  '@media (max-width:767px)':{
    height:'34px',
    width: '80%',
    top: 'inherit',
    bottom: '46px',
  }
},
expiry_text: {
  fontFamily:theme.fontFamily.fontFamilyRegular,
  color: "#FFFFFF",
  fontSize: "12px",
  padding: 0,
  paddingTop: "2px",
  paddingBottom: "2px",
  margin: 0,
  marginLeft: "6px",
  "&.expired": {
    color: "black",
  },
  '@media (max-width:767px)':{
    fontSize:'10px'
  }
},
bold_expiry: {
  fontSize: "13px",
  fontFamily: theme.fontFamily.fontFamilyBold,
  "&.expired": {
    color: "#6551FF",
  },
  '@media (max-width:767px)':{
    fontSize:'11px'
  }
},



}));

const ChallengeCardSelect = (props)=>{
  const classes =  useStylesChallengeSelectCard();
  const {challengeTitle,onClick ,isHackathonEnable,selectedChallengeId,singleChallengeId,images,submissionsEnd,decs,isHackathonChallenge,isInnovate,innovateChallengeTagIdeaCount} = props || {}
  // const isHackthonCheck = getInitiativeFlag({isHackathonChallenge,isInnovate})
  // console.log("🚀 ~ ChallengeCardSelect ~ selectedChallengeId:", selectedChallengeId)
  return (
    <div className={`${classes.cardBox}  ${selectedChallengeId !== singleChallengeId ? null : classes.selectedChallenge}`}>
      
      <div className={classes.block1}>
        <ChallengeImage src={images} />
        {/* <h4 className={classes.flags}>{isHackthonCheck}</h4>   */}
        <ExpiryInfo ends={submissionsEnd} numIdeas={innovateChallengeTagIdeaCount} classes={classes} myChallengeHide={false} />
      </div>
      <div className={classes.block2}>
        {/* <span><BiBulb /></span> */}
        <h3 className={classes.heading}>{challengeTitle}</h3>
        <p className={classes.textsmall}><span>Description</span> : {decs}</p>
                <p className={classes.textsmall}><span>Submissions End </span> : {submissionsEnd}</p>
                {/* <p className={classes.textsmall}><span>Category </span> : {category}</p> */}
        {/* <h4 className={classes.flags}>{isHackathonEnable ? 'isHackthon' : 'Nova'}</h4> */}
        {/* {selectedChallengeId !== singleChallengeId ? */}
          <button type='button'
            onClick={onClick}
            className={classes.selectbtn}>Select</button>
          {/* : */}
          {/* <button type='button' className={classes.selectbtn}>Selected</button> */}
        {/* } */}
      </div>
    </div>
  )
}

